(function () {
  let initialized = false;

  function init() {
    if (initialized) return;

    const productGrid = document.querySelector('#product-grid');
    const container = document.querySelector('#ProductGridContainer');
    const nextLink = document.querySelector('.pagination__item--prev.pagination__item-arrow');

    if (!productGrid || !container || !nextLink) return;

    initialized = true;

    let nextPageUrl = nextLink.href;
    let loading = false;

    // Skrij pagination
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    if (paginationWrapper) paginationWrapper.style.display = 'none';

    // Loading spinner
    const spinner = document.createElement('div');
    spinner.id = 'infinite-scroll-spinner';
    spinner.innerHTML = '<div style="text-align:center;padding:20px;color:#666;">Nalagam...</div>';
    spinner.style.display = 'none';
    container.appendChild(spinner);

    function getNextPageUrl(doc) {
      const link = (doc || document).querySelector('.pagination__item--prev.pagination__item-arrow');
      return link ? link.href : null;
    }

    function isNearBottom() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return false;
    const gridBottom = grid.getBoundingClientRect().bottom;
    return gridBottom < window.innerHeight * 2;
    }


    function loadMore() {
      if (loading || !nextPageUrl) return;
      loading = true;
      spinner.style.display = 'block';

      fetch(nextPageUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('#product-grid .grid__item');

          newItems.forEach(item => productGrid.appendChild(item));

          nextPageUrl = getNextPageUrl(doc);
          loading = false;
          spinner.style.display = 'none';

          if (!nextPageUrl) {
            spinner.remove();
            window.removeEventListener('scroll', onScroll);
          }
        })
        .catch(() => {
          loading = false;
          spinner.style.display = 'none';
        });
    }

    function onScroll() {
      if (isNearBottom()) loadMore();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Poskusi takoj
  init();

  // Če ni šlo, čakaj na DOM spremembe
  const observer = new MutationObserver(() => {
    if (!initialized) init();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Tudi po DOMContentLoaded in load
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
